import React from 'react';

import { FormattedDate, FormattedMessage } from 'react-intl';

import { Tooltip } from 'components/tooltips/Tooltip';

import type { BeamerUpdate } from '../api/loginApi';

type PlatformUpdatesProps = {
    updates: BeamerUpdate[];
};

const UpdateTooltipContent = ({ update }: { update: BeamerUpdate }) => (
    <div className="tw-w-[260px]">
        {update.image && (
            <img
                src={update.image}
                alt={update.title}
                className="tw-w-full tw-h-[120px] tw-object-cover tw-rounded tw-mb-8"
            />
        )}
        <p className="tw-text-s tw-font-semibold tw-text-primary tw-leading-snug tw-mb-4">
            {update.title}
        </p>
        {update.content && (
            <p className="tw-text-s tw-text-secondary tw-leading-snug tw-mb-4 tw-whitespace-pre-line">
                {update.content}
            </p>
        )}
        <span className="tw-text-s tw-text-tertiary">
            <FormattedDate value={update.date} month="short" day="numeric" year="numeric" />
        </span>
    </div>
);

const chipClassName =
    'tw-inline-flex tw-items-center tw-gap-4 tw-text-s tw-text-white/80 hover:tw-text-[#86d9d6] tw-transition-colors tw-duration-200 tw-bg-white/5 hover:tw-bg-white/10 tw-rounded-full tw-px-12 tw-py-4 tw-cursor-default';

const ChipContent = ({ title }: { title: string }) => (
    <>
        <span className="tw-w-[5px] tw-h-[5px] tw-rounded-full tw-bg-primary tw-shrink-0" />
        <span className="tw-truncate tw-max-w-[160px]">{title}</span>
    </>
);

const UpdateChip = ({ update }: { update: BeamerUpdate }) => {
    return (
        <Tooltip
            side="top"
            content={<UpdateTooltipContent update={update} />}
            trigger={
                <span className={chipClassName}>
                    <ChipContent title={update.title} />
                </span>
            }
        />
    );
};

export const PlatformUpdates = ({ updates }: PlatformUpdatesProps) => {
    if (updates.length === 0) return null;

    return (
        <div className="tw-mt-12 tw-pt-12 tw-border-t tw-border-white/15 tw-pt-10">
            <div className="tw-flex tw-items-center tw-gap-8 tw-flex-wrap">
                <span className="tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-xx-loose tw-text-white/50 tw-shrink-0">
                    <FormattedMessage id="login.updates.title" defaultMessage="What's New" />
                </span>

                {updates.map((update) => (
                    <UpdateChip key={update.id} update={update} />
                ))}
            </div>
        </div>
    );
};
